export default __webpack_public_path__ + "static/ABCMaxiRoundMono-Regular-32e29fa71fced3d0e53d877bf010b1ca.woff2";